import React from 'react'
import { ReactComponent as Resource } from '../../assets/ic_resource.svg';

const ResourceIcon = () => <Resource />;

export default ResourceIcon;
